import {commonParams} from '../utils/segment-utils'

/**
 *  This is used to create a new context only for menu item clicks
 */
const getMenuEventContext = (baseContext, item) => ({
    ...baseContext,
    linkText: item?.name ?? '',
    isMenuItem: true
})

/**
 *  This is will be executed from category meny clicks and header click for login, wishlist
 */
export const mainMenuItemSelected = async (item, segmentContext) => {
    const userId = segmentContext?.customerId
    const eventContext = getMenuEventContext(segmentContext, item)

    const params = await commonParams(eventContext)
    params.menuCategory = item?.parentCategoryTree?.[0]?.name
    params.menuType = 'Horizontal'

    window?.analytics?.track('Main Menu Item Selected', params, eventContext?.context, userId)
}

/**
 *  This is will be executed from serach box and if we enter
 */
export const searchActionSubmitted = async (searchText, segmentContext) => {
    const searchTextParams = searchText?.toLowerCase()?.split(' ')
    const userId = segmentContext?.customerId
    const eventContext = getMenuEventContext(segmentContext)

    const params = await commonParams(eventContext)
    params.searchAction = 'Submitted Search'
    params.searchWords = searchTextParams

    window?.analytics?.track('Search Action Submitted', params, eventContext?.context, userId)
}

/**
 *  This is will be executed from serach box, if we click on categories, products etc
 */
export const searchSuggetionsSubmitted = async (
    searchText,
    suggestion,
    selectedProductId,
    segmentContext
) => {
    const userId = segmentContext?.customerId
    const eventContext = getMenuEventContext(segmentContext)
    const searchTextParams = searchText?.toLowerCase()?.split(' ')
    const product = suggestion?.productSuggestions?.find(
        (product) => product?.productId === selectedProductId
    )

    const params = await commonParams(eventContext)
    params.searchAction = 'Suggested Search'
    params.searchWords = [searchTextParams]
    params.suggestionCategory = ''
    params.storeData.price = product?.price
    params.storeData.productName = product?.name
    params.storeData.sku = product?.productId

    window?.analytics?.track('Search Action Submitted', params, eventContext?.context, userId)
}
